import React from 'react';
import classes from './App.module.css';
import { Routes, Route } from 'react-router-dom';
import Layout from './hoc/Layout/Layout';
import Main from './Main';

function App() {
	let routes = (
		<Routes>
			<Route path='/' element={<Main />} />
		</Routes>
	);
	return (
		<div className={classes.App}>
			<Layout>{routes}</Layout>
		</div>
	);
}

export default App;
